/* eslint-disable @next/next/no-img-element */
import MembershipStyles from '../../styles/elements/MembershipStyles.module.scss';
import { urlFor } from '../../lib/sanity';
import Link from 'next/link';

const MembershipBlock = ({ Memberships }) => {
  return (
    <div className={MembershipStyles.memberships}>
      {Memberships?.length > 0 &&
        Memberships.map((membership) => (
          <Link href={membership.website} key={membership._id}>
            <div className={MembershipStyles.memimage}>
              <img src={urlFor(membership.image).auto('format').width(270).height(150).url()} alt={membership.title} className={MembershipStyles.imgclass} width="270" height="150" />
              <div className={MembershipStyles.benefithint}>
                <div className={MembershipStyles.benefitcopy}>{membership.benefit}</div>
              </div>
            </div>
            <div className={MembershipStyles.memtitle}>{membership.title}</div>
          </Link>
        ))}
    </div>
  );
};

export default MembershipBlock;
